/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Prep_Invite_TitleInputs */



/**
* | output |
* | --- |
* | "Prepare this conversation" |
*
* @param {Meeting_Prep_Invite_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_prep_invite_title = /** @type {((inputs?: Meeting_Prep_Invite_TitleInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Prep_Invite_TitleInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Maak je voorbereiding")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Préparez cette conversation")
	return /** @type {LocalizedString} */ ("Prepare this conversation")
});